import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import RoutingForm from './RoutingForm'

function RoutingList(props) {
  const {
    isFormDisabled,
    valueKey,
    saveData,
    updateData,
    deleteData,
    dataList,
    dataSource,
    autoFocus,
    fieldType,
    copyDocument,
    handleCopyEnabled,
    ...rest
  } = props

  const dragItem = useRef()
  const dragOverItem = useRef()

  const dispatch = useDispatch()

  const dragStart = (e,position)=>{
    dragItem.current = position
  }

  const dragEnter = (e,position)=>{
    dragOverItem.current = position;
  }

  const drop =() =>{
    const copyListItems = [...dataList];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current,1)
    copyListItems.splice(dragOverItem.current,0,dragItemContent)
    dispatch({
      type:'HANDLE_DND',
      payload:copyListItems 
    })
    rest.saveRearrange({"routingCountry":[{id:dragItemContent?.id, orderNumber:dragOverItem.current+1}]})
    dragItem.current = null;
    dragOverItem.current=null;

   
  }


  return (
    <div
      id='rountingCountryList'
      className='dropdownList'
      style={{ marginTop: '10px' ,minHeight:'14rem'}}
    >
      {dataList &&
        dataList.map((item, idx) => {
          return (
            <div
            onDragStart={(e)=>dragStart(e,idx)}
            onDragEnter={(e) => dragEnter(e, idx)}
            onDragEnd={drop}
            onDragOver={(e) => e.preventDefault()}
            draggable={rest?.draggable}
            >
              <RoutingForm
                key={'container' + idx}
                itemNumber={idx + 1}
                item={item}
                valueKey={valueKey}
                isFormDisabled={isFormDisabled}
                saveData={saveData}
                updateData={updateData}
                deleteData={deleteData}
                dataSource={dataSource}
                autoFocus={autoFocus}
                fieldType={fieldType}
                copyDocument={copyDocument}
                handleCopyEnabled={handleCopyEnabled}
                {...rest}
              />
            </div>
          )
        })}
    </div>
  )
}

export default RoutingList
